
<div class="help-page">
  <iframe
    class="help-page__manual"
    src="/html-tree/"
    title="Re:Column Help"
  ></iframe>
</div>
